module.exports = __webpack_public_path__ + "static/media/KEY.9388cbe9.svg";